import { render, staticRenderFns } from "./NewItem.vue?vue&type=template&id=16efaac6"
import script from "./NewItem.vue?vue&type=script&lang=js"
export * from "./NewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports